import { useAuthQuery } from 'hooks';
import { DAPlayer } from 'types';

export const useDAStep = (stageId: number) => {
  return useAuthQuery<DAPlayer[]>(['doc-acquisition', stageId, 'players']);
};
